import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";

// The always-on search box in the header (owner ask, Sep 2026) — every page
// carries a way to jump straight to a job/visit/PO/customer/property by name
// or number, rather than navigating to the right list first. Submitting sends
// the browser to /search?q=…, where SearchResults.jsx does the actual work;
// this component is deliberately just an input + a navigate call.
export default function GlobalSearchBar({ className = "", defaultValue = "" }) {
  const [query, setQuery] = useState(defaultValue);
  const navigate = useNavigate();

  function submit(e) {
    e.preventDefault();
    const q = query.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
  }

  return (
    <form onSubmit={submit} className={className}>
      <div className="relative">
        <Search className="absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-ink-muted pointer-events-none" aria-hidden="true" />
        <input
          type="search"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search…"
          title="Search jobs, visits, POs, customers and properties"
          aria-label="Search the portal"
          className="w-full pl-8 pr-3 py-1.5 text-sm bg-surface-inset border border-zinc-300 rounded-full text-ink placeholder:text-ink-subtle focus:outline-none focus:ring-2 focus:ring-brand-300 focus:border-brand-400"
        />
      </div>
    </form>
  );
}
